import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from '@mui/material';
import DocumentTickIcon from 'app/assets/images/IconImages/DocumentTickIcon.svg';
import TaskOutlinedIcon from '@mui/icons-material/TaskOutlined';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { placementStatusAction } from 'store/redux-store/placement-status/slice';
import { redirectToClientConfirmationDocEditor } from './utils';
import { ff_isPlacementStatusDisabled } from '../NextPlacementStatus/Helper';
import { placementStatusOptions } from '../NextPlacementStatus/StatusDefaults';

export const CreateClientConfirmationBtn: React.FC<{ onClickWithCallback?: (callbackFn) => void }> = ({
  onClickWithCallback = undefined,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const history = useNavigate();
  const location = useLocation();

  const _onClick = React.useCallback(() => {
    /** Code: Close client confirmation dialog */
    dispatch(placementStatusAction.setSelectedStatus({ status: undefined }));
    redirectToClientConfirmationDocEditor(history, location);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  const handleClick = React.useCallback(() => {
    if (!!onClickWithCallback) onClickWithCallback(_onClick);
    else _onClick();
  }, [onClickWithCallback, _onClick]);

  return (
    <Link
      onClick={handleClick}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: '6px',
        textTransform: 'uppercase',
      }}
    >
      <img src={DocumentTickIcon} alt="DocumentTickIcon" />
      <div>{t('placement.profile.createConfirmation.create')}</div>
    </Link>
  );
};

export const CreateClientConfirmationXGridBtn = ({
  disableDueToStatus = false,
  onClick = undefined,
  currentPlacementStatus,
  statusChangeDecision,
  disabled = false,
}) => {
  const { t } = useTranslation();

  const isEnabled = useMemo(() => {
    if (!currentPlacementStatus || !statusChangeDecision) return false;
    return !ff_isPlacementStatusDisabled(
      statusChangeDecision,
      placementStatusOptions.clientConfirmation,
      currentPlacementStatus,
    );
  }, [currentPlacementStatus, statusChangeDecision]);

  return [
    {
      title: t('placement.profile.confirmation'),
      Icon: TaskOutlinedIcon,
      disabled: !isEnabled || disableDueToStatus || disabled,
      tooltipProps: {
        tooltipContent: !isEnabled
          ? t('placement.profile.clientConfirmation.featureDisabled')
          : disableDueToStatus
          ? t('placement.profile.clientConfirmation.disabledDueToPlacementStatus')
          : null,
        disabled: isEnabled && !disableDueToStatus,
      },
      onClick: event => {
        onClick?.(event);
      },
    },
  ];
};
